/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentDetailsInternalTransferInvestmentViewModel
 */
export interface PaymentDetailsInternalTransferInvestmentViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsInternalTransferInvestmentViewModel
     */
    premiumId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsInternalTransferInvestmentViewModel
     */
    premiumInternalTransferId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsInternalTransferInvestmentViewModel
     */
    originatingSchemeId?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsInternalTransferInvestmentViewModel
     */
    investmentName?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsInternalTransferInvestmentViewModel
     */
    planNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsInternalTransferInvestmentViewModel
     */
    estimatedTransferAmount?: number;
}

/**
 * Check if a given object implements the PaymentDetailsInternalTransferInvestmentViewModel interface.
 */
export function instanceOfPaymentDetailsInternalTransferInvestmentViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaymentDetailsInternalTransferInvestmentViewModelFromJSON(json: any): PaymentDetailsInternalTransferInvestmentViewModel {
    return PaymentDetailsInternalTransferInvestmentViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsInternalTransferInvestmentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsInternalTransferInvestmentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'premiumId': !exists(json, 'PremiumId') ? undefined : json['PremiumId'],
        'premiumInternalTransferId': !exists(json, 'PremiumInternalTransferId') ? undefined : json['PremiumInternalTransferId'],
        'originatingSchemeId': !exists(json, 'OriginatingSchemeId') ? undefined : json['OriginatingSchemeId'],
        'investmentName': !exists(json, 'InvestmentName') ? undefined : json['InvestmentName'],
        'planNumber': !exists(json, 'PlanNumber') ? undefined : json['PlanNumber'],
        'estimatedTransferAmount': !exists(json, 'EstimatedTransferAmount') ? undefined : json['EstimatedTransferAmount'],
    };
}

export function PaymentDetailsInternalTransferInvestmentViewModelToJSON(value?: PaymentDetailsInternalTransferInvestmentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PremiumId': value.premiumId,
        'PremiumInternalTransferId': value.premiumInternalTransferId,
        'OriginatingSchemeId': value.originatingSchemeId,
        'InvestmentName': value.investmentName,
        'PlanNumber': value.planNumber,
        'EstimatedTransferAmount': value.estimatedTransferAmount,
    };
}

